function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  y1: 1.003,
  x2: 0.5,
  y2: 0.003,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#eaeaf3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#babed1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9399b5"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "past_activity_2",
  transform: "translate(0 0.048)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_35338",
  "data-name": "Group 35338"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7061",
  "data-name": "Ellipse 7061",
  cx: 75,
  cy: 75,
  r: 75,
  transform: "translate(0 -0.048)",
  fill: "#eaeaf3"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_35336",
  "data-name": "Group 35336"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_35333",
  "data-name": "Group 35333"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63305",
  "data-name": "Path 63305",
  d: "M43.229,24.852h63.542a6.11,6.11,0,0,1,6.11,6.11v87.982a6.11,6.11,0,0,1-6.11,6.11H43.229a6.11,6.11,0,0,1-6.11-6.11V30.962A6.109,6.109,0,0,1,43.229,24.852Z",
  transform: "translate(150 149.906) rotate(180)",
  fill: "url(#linear-gradient)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_35334",
  "data-name": "Group 35334"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63306",
  "data-name": "Path 63306",
  d: "M107.993,120.367H42.007a.2.2,0,0,1-.2-.2V29.74a.2.2,0,0,1,.2-.2h65.986a.2.2,0,0,1,.2.2v90.425A.2.2,0,0,1,107.993,120.367Zm-65.784-.4h65.582V29.942H42.209Z",
  fill: "#eaeaf3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_35335",
  "data-name": "Group 35335"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18306",
  "data-name": "Rectangle 18306",
  width: 18.329,
  height: 2.444,
  transform: "translate(83.399 35.85)",
  fill: "#969bb7"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18307",
  "data-name": "Rectangle 18307",
  width: 18.329,
  height: 2.444,
  transform: "translate(83.399 40.738)",
  fill: "#b6bacc"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18308",
  "data-name": "Rectangle 18308",
  width: 18.329,
  height: 2.444,
  transform: "translate(83.399 45.625)",
  fill: "#d1d5e0"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18309",
  "data-name": "Rectangle 18309",
  width: 54.988,
  height: 2.444,
  transform: "translate(46.74 54.179)",
  fill: "#eaeaf3"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18310",
  "data-name": "Rectangle 18310",
  width: 54.988,
  height: 2.444,
  transform: "translate(46.74 61.511)",
  fill: "#eaeaf3"
}))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18311",
  "data-name": "Rectangle 18311",
  width: 54.988,
  height: 2.444,
  transform: "translate(47.506 104.202)",
  fill: "#b9bdd0"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18312",
  "data-name": "Rectangle 18312",
  width: 54.988,
  height: 2.444,
  transform: "translate(47.506 111.534)",
  fill: "#b9bdd0"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18313",
  "data-name": "Rectangle 18313",
  width: 29.553,
  height: 2.444,
  transform: "translate(60.224 96.871)",
  fill: "#b9bdd0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_63307",
  "data-name": "Path 63307",
  d: "M86.372,96.871H63.628l3.488-17.9A3.248,3.248,0,0,1,70.3,76.348h9.391a3.248,3.248,0,0,1,3.188,2.627Z",
  fill: "url(#linear-gradient-2)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18314",
  "data-name": "Rectangle 18314",
  width: 5.139,
  height: 2.444,
  transform: "translate(76.222 67.313) rotate(90)",
  fill: "#b9bdd0"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18315",
  "data-name": "Rectangle 18315",
  width: 7.666,
  height: 2.444,
  transform: "translate(76.222 91.648) rotate(90)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18316",
  "data-name": "Rectangle 18316",
  width: 3.688,
  height: 2.444,
  transform: "translate(87.616 72.755) rotate(135)",
  fill: "#b9bdd0"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_18317",
  "data-name": "Rectangle 18317",
  width: 3.688,
  height: 2.444,
  transform: "translate(64.113 71.015) rotate(45)",
  fill: "#b9bdd0"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_35337",
  "data-name": "Group 35337"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63308",
  "data-name": "Path 63308",
  d: "M75,85.766a1.779,1.779,0,1,1-1.779,1.779A1.781,1.781,0,0,1,75,85.766m0-3a4.779,4.779,0,1,0,4.779,4.779A4.779,4.779,0,0,0,75,82.766Z",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_35340",
  "data-name": "Group 35340"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63309",
  "data-name": "Path 63309",
  d: "M56.347,34.3A7.7,7.7,0,0,0,48.652,42H47.459L49.4,45.085,51.349,42H50.192A6.163,6.163,0,1,1,52,46.348l-1.09,1.09A7.695,7.695,0,1,0,56.347,34.3Z",
  fill: "#969bb7"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_35339",
  "data-name": "Group 35339"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63310",
  "data-name": "Path 63310",
  d: "M59.364,42.766H55.552V37.39h1.539v3.837h2.273Z",
  fill: "#969bb7"
}))));

var SvgEmptyPastActivity = function SvgEmptyPastActivity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyPastActivity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty-past-activity.2ed31f02.svg";
export { ForwardRef as ReactComponent };